// import Card from "../../../models/common/Card";
// import iconOne from '../../../assets/img/partnerPortal/homepage/vector_1.png';
// import iconTwo from '../../../assets/img/partnerPortal/homepage/vector_2.png';
// import iconThird from '../../../assets/img/partnerPortal/homepage/vector_3.png';


// BANNER
export const TITLE = <div>AppDeveloper Services Specialization</div>;
export const SUB_TITLE = <div>Powerful apps for your customers, built by you.</div>;
// export const BUTTON_NAME = "Login";
// export const BUTTON_LINK = "https://sso-access.partners.dynatrace.com";
// export const SECOND_BUTTON_NAME = "Register";
// export const SECOND_BUTTON_LINK = "https://partners.dynatrace.com/#/page/registration";
// --



// BENEFITS CARDS

// const card1: Card = new Card("About our partner portal", "Learn more", iconOne, undefined, "https://www.dynatrace.com/resources/partners/about-partner-program.html");
// const card2: Card = new Card("Why partner with Dynatrace", "Learn more", iconTwo, undefined, "https://www.dynatrace.com/resources/partners/why-partner.html");
// const card3: Card = new Card("Find a Dynatrace Partner", "Learn more", iconThird, undefined, "https://www.dynatrace.com/partners/solution-partners/");

// const cardsFirstRow: Card[] = [card1, card2, card3];


// export const ALL_CARD_ROWS: Record<number, Card[]> = {
//   [0]: cardsFirstRow
// }
// -- 


// SIGN UP
// export const SIGN_UP_TITLE = "Interested in partnering with us?";
// export const SIGN_UP_SUB_TITLE = "Just complete a quick application form and we’ll be in touch to get you started.";
// export const BANNER_LINK = "https://www.dynatrace.com/partners/#next-steps";
// export const BUTTON_NAME_SIGN_UP = "Become a Partner";
// --



